
// You can write more code here

/* START OF COMPILED CODE */

import BaseButton from "../core/BaseButton";
import UIButton from "../core/components/UIButton";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class BtnNextLevel extends BaseButton {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 81.5, y ?? 81.5);

    // btn
    const btn = scene.add.image(0, 0, "common", "btn-endscreen.png");
    this.add(btn);

    // iconArrow
    const iconArrow = scene.add.image(15, 0, "common", "icon-next.png");
    this.add(iconArrow);

    // note
    const note = scene.add.image(-15, -2, "common", "note.png");
    note.scaleX = 0.675;
    note.scaleY = 0.675;
    note.angle = 2;
    this.add(note);

    // price
    const price = scene.add.text(-18, 1, "", {});
    price.setOrigin(0.5, 0.5);
    price.text = "500";
    price.setStyle({ "color": "#ffffffff", "fontFamily": "FREDFREDBURGER-BOLD", "fontSize": "28px" });
    this.add(price);

    // this (components)
    new UIButton(this);

    this.iconArrow = iconArrow;
    this.note = note;
    this.price = price;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private iconArrow: Phaser.GameObjects.Image;
  private note: Phaser.GameObjects.Image;
  private price: Phaser.GameObjects.Text;

  /* START-USER-CODE */

  public showUnlockCost(unlockCost: number) {
    this.note.visible = true;
    this.price.visible = true;
    this.price.text = unlockCost.toString();
  }

  public hideUnlockCost() {
    this.note.visible = false;
    this.price.visible = false;
    this.iconArrow.x = 0;
  }

  public onPurchase(completeDelay: number, callback: () => void) {
    this.scene.add.tween({
      targets: [this.note, this.price],
      alpha: 0,
      scale: 1.6,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.InOut,
      onComplete: () => {
        this.note.setVisible(false);
        this.price.setVisible(false);
        callback?.();
      },
      completeDelay: completeDelay
    });

    this.scene.add.tween({
      targets: [this.iconArrow],
      x: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.InOut
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
